const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 500,
      scaleMode: 'zoom',

      initialZoomLevel: 'fit',
      secondaryZoomLevel: 'fill',
      maxZoomLevel: 'fill',

      gallery: this,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: false,
      closeOnVerticalDrag: true,
      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addInstructions()
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: window.theme.strings.photoswipe.close,
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addInstructions () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-info',
      className: 'pswp-Action_Instructions fz-18_100',
      appendTo: 'wrapper',
      html: `<p class="pswp-Action_Instruction pswp-Action_Instruction-closer">${window.theme.strings.photoswipe.closer}</p><p class="pswp-Action_Instruction pswp-Action_Instruction-farther">${window.theme.strings.photoswipe.farther}</p>`,
    })
  }

  get closeSvg () {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 15">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M2.373 2.377 12.62 12.623m0-10.246L2.373 12.623"/>
      </svg>
    `
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
